/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zesty_Knotty_Crab_IntendInputs */

const fr_zesty_knotty_crab_intend = /** @type {(inputs: Zesty_Knotty_Crab_IntendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme`)
};

/**

* @param {Zesty_Knotty_Crab_IntendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const zesty_knotty_crab_intend = /** @type {((inputs?: Zesty_Knotty_Crab_IntendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zesty_Knotty_Crab_IntendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_zesty_knotty_crab_intend(inputs)
});